var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-input-container"},[_c('h3',{staticClass:"test-description"},[_vm._v("Typ het woord")]),_c('c-input',{staticClass:"test-input",model:{value:(_vm.currentInput),callback:function ($$v) {_vm.currentInput=$$v},expression:"currentInput"}}),_c('c-next-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }